import script from "./AdvancedOperations.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdvancedOperations.vue?vue&type=script&setup=true&lang=ts"

import "./AdvancedOperations.vue?vue&type=style&index=0&id=48bf2174&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48bf2174"]])

export default __exports__